/** «**слово**» в тексте → выделение жирным. */
export const rich = (text: string) =>
  text.split(/\*\*(.+?)\*\*/g).map((part, i) => (i % 2 ? <b key={part}>{part}</b> : part));
